/* Craftsbazaar FAQ page. Scoped to .cb-faq, safe with multiple instances.
   - Scroll reveal (additive: content is visible without JS)
   - Animated single-open accordion (native <details> remains the fallback)
   - Topic filter pills */
(function () {
  var EASE = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = root.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function open(d) {
    var wrap = d.querySelector('.a-wrap');
    if (!wrap || d.dataset.anim) return;
    d.dataset.anim = '1';
    d.open = true;
    var h = wrap.scrollHeight;
    wrap.style.height = '0px';
    wrap.getBoundingClientRect();
    wrap.style.transition = 'height 260ms ' + EASE;
    wrap.style.height = h + 'px';
    wrap.addEventListener('transitionend', function te(e) {
      if (e.propertyName !== 'height') return;
      wrap.style.height = ''; wrap.style.transition = '';
      delete d.dataset.anim;
      wrap.removeEventListener('transitionend', te);
    });
  }

  function close(d) {
    var wrap = d.querySelector('.a-wrap');
    if (!wrap || d.dataset.anim) return;
    d.dataset.anim = '1';
    var h = wrap.scrollHeight;
    wrap.style.height = h + 'px';
    wrap.getBoundingClientRect();
    wrap.style.transition = 'height 200ms ' + EASE;
    wrap.style.height = '0px';
    wrap.addEventListener('transitionend', function te(e) {
      if (e.propertyName !== 'height') return;
      d.open = false; wrap.style.height = ''; wrap.style.transition = '';
      delete d.dataset.anim;
      wrap.removeEventListener('transitionend', te);
    });
  }

  function accordion(root) {
    root.querySelectorAll('.qa').forEach(function (d) {
      var summary = d.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        if (reduce) return; // native toggle handles it
        e.preventDefault();
        if (d.open) { close(d); return; }
        // single-open: close open siblings within the same list
        var list = d.closest('.qa-list');
        if (list) {
          list.querySelectorAll('.qa[open]').forEach(function (other) {
            if (other !== d) close(other);
          });
        }
        open(d);
      });
    });
  }

  function filters(root) {
    var pills = root.querySelectorAll('.pill');
    var groups = root.querySelectorAll('.group');
    if (!pills.length) return;
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var cat = p.dataset.cat;
        pills.forEach(function (x) {
          var on = x === p;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        groups.forEach(function (g) {
          g.style.display = (cat === 'all' || g.dataset.cat === cat) ? '' : 'none';
        });
      });
    });
  }

  function init(root) {
    root.classList.add('is-js');
    reveal(root);
    accordion(root);
    filters(root);
  }

  function boot() { document.querySelectorAll('.cb-faq').forEach(init); }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();
